import { IMCourse } from '../types'
import { createNodeList } from '../../nodeCreationHelpers'
import { ISimplifiedNode } from '../../../components/ingestion/IngestedTree'
import { IM360Parser } from './IM360Parser'
import { createDocumentNode } from './createNodeWrappers'

export function courseOverview(imCourse: IMCourse) {
  const childNodes = children(imCourse)
  if (!childNodes.length) return []
  return [
    createNodeList(
      {
        title: 'Course Overview',
      },
      [
        createDocumentNode('Course Overview', [
          createNodeList({ title: 'Course Overview' }, childNodes),
        ]),
      ],
    ),
  ]
}

function children(imCourse: IMCourse) {
  const { curricula } = imCourse
  const childrenContent: [string, string | undefined][] = [
    ['About these Materials', curricula.about],
    ['Further Reading', curricula.further_reading],
    ['Design Principles', curricula.design_principles],
    ['A Typical IM Lesson', curricula.typical_lesson],
    ['Each Lesson and Unit Tells a Story', curricula.lesson_unit_stories],
    ['Launch - Work - Synthesize', curricula.launch_work_synthesize],
    ['Practice Problems', curricula.prac_prob_how_to],
    ['Instructional Routines', curricula.instructional_routine],
    [
      'Noticing and Assessing Student Progress in Mathematical Practices',
      curricula.how_to_assess_progress,
    ],
    ['Center Overview', curricula.center_activities],
    ['Student Journal Prompts', curricula.student_journal_prompts],
    ['Support Math Community', curricula.support_math_community],
    ['PLC Structure', curricula.plc_structure],
    ['K5 Representations', curricula.k5_representations],
    [
      'Mathematical Language Development and Access for English Learners',
      curricula.supporting_english_language_learners,
    ],
    [
      'Universal Design for Learning and Access for Students with Disabilities',
      curricula.supporting_students_with_disabilities,
    ],
    ['Learning Goals and Targets', curricula.assessment_goals_targets],
    ['How to Assess Progress', curricula.how_to_assess_progress],
    ['Pre Unit Practice Problems', curricula.assessment_pre_unit],
    ['Cool-Downs', curricula.assessment_cool_downs],
    ['Summative Assessments', curricula.assessment_end_of_unit],
    ['pacing guides and dependency diagrams', curricula.pacing_guide],
    ['Instructional Routines', curricula.instructional_routine],
    ['Contributors', curricula.contributors],
    ['Corrections', imCourse.corrections],
  ]
  return childrenContent.reduce<ISimplifiedNode[]>((acc, [t, content]) => {
    if (!content) return acc
    return [
      ...acc,
      createDocumentNode(t, [
        IM360Parser.getInstance().createNoteNode({
          title: t,
          value: content,
          studentFacing: false,
        }),
      ]),
    ]
  }, [])
}
